exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.status_2[data-v-5ee9ce88] {\n    color: #da511b;\n    background-color : #FFF!important;\n}\n.status_3[data-v-5ee9ce88] {\n    color: #09ae14;\n    background-color : #FFF!important;\n}\n.status_5[data-v-5ee9ce88] {\n    color: #6d3a6d;\n    background-color : #FFF!important;\n}\n.status_6[data-v-5ee9ce88] {\n    color: #77777e;\n    background-color : #FFF!important;\n}\n.ticket_status[data-v-5ee9ce88] {\n    border: 1px solid #dcdfe6;\n    border-radius: 2px;\n    padding: 0 2px;\n    background-color: #ecf5ff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ee9ce88","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/mobile-ticket/MobileTicketStatus.vue
// module id = 625
// module chunks = 75